import {
  useProfileReduced,
  useProfilesReduced,
} from '@/core/domain/enterprise/Profiles/Profiles.hooks';
import useSelectOptions from '@/hooks/useSelectOptions';
import { Select, SelectProps } from 'antd';
import { useState } from 'react';

const ProfileSelect: React.FC<SelectProps> = (props) => {
  const [selectClicked, setSelectClicked] = useState<boolean>(false);

  const profileList = useProfilesReduced(selectClicked);
  const profileDetail = useProfileReduced();

  const handleSelectClick = () => {
    if (!selectClicked) {
      setSelectClicked(true);
    }
  };

  const selectOptions = useSelectOptions({
    detail: profileDetail,
    directList: profileList,
    selectProps: props,
    labelFormatter: (profile) => profile.name,
  });

  return (
    <Select onClick={handleSelectClick} {...props} options={selectOptions} />
  );
};

export default ProfileSelect;
